// src/admin/purge/PurgeSummaries.jsx — what a purge will do, in our words (v206, decision D6).
// ⛔ Never paths, collection or table names, `not_purgeable` / `warnings` (English): see purge/purgeModel.js.
// v212: the tenant and person summaries list the companies the purge leaves with no tenant (OrphanCompanies — needs a
// Router); CompanyPurgeSummary for the company dialog.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { withEmphasis } from '../../components/ui/emphasis.jsx';
import { memberLines, personOutcome, tenantNamesFor, tenantPreviewLines } from './purgeModel.js';
import { COLORS, FONT_SANS } from '../../constants/theme.js';
import OrphanCompanies from '../companies/OrphanCompanies.jsx';
import { companyPreviewLines, orphanCompanies } from '../companies/companyModel.js';

const text = { color: COLORS.ink, fontSize: '13px', lineHeight: 1.5, margin: '0 0 8px', fontFamily: FONT_SANS };
const muted = { ...text, color: COLORS.textSecondary, fontSize: '12px' };
const list = { ...text, paddingLeft: '18px' };

export function TenantPurgeSummary({ preview }) {
  const { t } = useTranslation('admin');
  const members = memberLines(preview);
  return (
    <div>
      <p style={text}>{withEmphasis(t('purge.tenant.intro'))}</p>
      <ul style={list}>
        {tenantPreviewLines(preview).map((line) => <li key={line.key}>{t(line.key, line.params)}</li>)}
      </ul>
      <p style={text}>{t('purge.groups.members')}</p>
      {members.length === 0 ? (
        <p style={muted}>{t('purge.groups.noMembers')}</p>
      ) : (
        <ul style={list}>
          {members.map((m) => (
            <li key={m.email}>
              {t('purge.member', { email: m.email, outcome: m.outcomeKey ? t(m.outcomeKey) : m.outcome })}
            </li>
          ))}
        </ul>
      )}
      <p style={text}>{t('purge.groups.kept')}</p>
      <OrphanCompanies companies={orphanCompanies(preview)} />
      <p style={muted}>{t('purge.groups.outOfReach')}</p>
    </div>
  );
}

export function PersonPurgeSummary({ preview, knownTenants = [] }) {
  const { t } = useTranslation('admin');
  const names = tenantNamesFor(preview, knownTenants);
  const body = personOutcome(preview) === 'anonymised'
    ? t('purge.person.bodyAnonymised')
    : t('purge.person.bodyDeleted', { tenants: names.length > 0 ? names.join(', ') : t('purge.person.noTenants') });
  return (
    <div>
      <p style={text}>{withEmphasis(body)}</p>
      <OrphanCompanies companies={orphanCompanies(preview)} />
      <p style={muted}>{t('purge.groups.outOfReach')}</p>
    </div>
  );
}

export function CompanyPurgeSummary({ preview, mode, tenantNames = [] }) {
  const { t } = useTranslation('admin');
  const members = memberLines(preview);
  return (
    <div>
      <p style={text}>{withEmphasis(t('purge.tenant.intro'))}</p>
      <ul style={list}>
        {companyPreviewLines(preview, mode, tenantNames).map((line) => <li key={line.key}>{t(line.key, line.params)}</li>)}
      </ul>
      <p style={text}>{t('purge.groups.members')}</p>
      {members.length === 0 ? (
        <p style={muted}>{t('purge.groups.noMembers')}</p>
      ) : (
        <ul style={list}>
          {members.map((m) => (
            <li key={m.email}>
              {t('purge.member', { email: m.email, outcome: m.outcomeKey ? t(m.outcomeKey) : m.outcome })}
            </li>
          ))}
        </ul>
      )}
      {mode === 'close' && <p style={text}>{t('purge.company.billingKept')}</p>}
      <p style={muted}>{t('purge.groups.outOfReach')}</p>
    </div>
  );
}
